import isNullOrUndefOrEmpty from "utils/isNullOrUndefOrEmpty";

/**
 * @typedef {import('types/api-responses').QuestionCompoundItem} QuestionCompoundItem
 */

/**
 * Determine if a compound question item's options represent a single-select (radio)
 * group rather than independent checkbox cells. Mirrors how flat radio questions are
 * shaped: every option shares the same qid (one underlying question) and has no ndata
 * (no independent "no" answer per option).
 * @param {QuestionCompoundItem} item - compound question item
 * @returns {boolean} true if the item's options should behave as radio (single-select)
 */
const isCompoundItemRadio = (item = {}) => {
  const { options = [] } = item;
  return (
    options.length > 0 && options.every((option) => option.qid === options[0].qid && isNullOrUndefOrEmpty(option.ndata))
  );
};

export default isCompoundItemRadio;
